// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_container__Knl8S {
  background-color: #3082f6;
  width: 25%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.Sidebar_logo__NP9ho {
  padding: 1.5rem 0;
}

.Sidebar_menu__3-oPo {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 85%;
  height: calc(100vh - 268px);
  overflow-y: auto;
}

.Sidebar_orgBtn__WYAzH,
.Sidebar_usersBtn__SDDh- {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
  padding: 10px;

  &:hover {
    background-color: #7aa9ed;
    border-radius: 10px;
  }
}

.Sidebar_activeBtn__jljNv {
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px;
  background-color: #7aa9ed;
}

.Sidebar_avatar__WsdnR {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
  font-weight: 500;
}

.Sidebar_userInfo__FTDHG {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  border-top: 1px solid white;
}

.Sidebar_content__g92PC {
  height: 100%;
  align-items: center;
  width: 85%;
  display: flex;
  justify-content: space-between;
}

.Sidebar_logOutIcon__3ibYA {
  cursor: pointer;
}

.Sidebar_avatar__WsdnR span {
  width: 100px;
  word-wrap: break-word;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;;EAEb;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".container {\n  background-color: #3082f6;\n  width: 25%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  padding: 1.5rem 0;\n}\n\n.menu {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: 85%;\n  height: calc(100vh - 268px);\n  overflow-y: auto;\n}\n\n.orgBtn,\n.usersBtn {\n  background-color: transparent;\n  border: none;\n  color: white;\n  font-size: 1rem;\n  cursor: pointer;\n  width: 100%;\n  padding: 10px;\n\n  &:hover {\n    background-color: #7aa9ed;\n    border-radius: 10px;\n  }\n}\n\n.activeBtn {\n  border: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 10px;\n  background-color: #7aa9ed;\n}\n\n.avatar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: white;\n  font-weight: 500;\n}\n\n.userInfo {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid white;\n}\n\n.content {\n  height: 100%;\n  align-items: center;\n  width: 85%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.logOutIcon {\n  cursor: pointer;\n}\n\n.avatar span {\n  width: 100px;\n  word-wrap: break-word;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sidebar_container__Knl8S`,
	"logo": `Sidebar_logo__NP9ho`,
	"menu": `Sidebar_menu__3-oPo`,
	"orgBtn": `Sidebar_orgBtn__WYAzH`,
	"usersBtn": `Sidebar_usersBtn__SDDh-`,
	"activeBtn": `Sidebar_activeBtn__jljNv`,
	"avatar": `Sidebar_avatar__WsdnR`,
	"userInfo": `Sidebar_userInfo__FTDHG`,
	"content": `Sidebar_content__g92PC`,
	"logOutIcon": `Sidebar_logOutIcon__3ibYA`
};
export default ___CSS_LOADER_EXPORT___;
